import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NotificationService} from '../../services/notification.service';

@Component({
  selector: 'idnow-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css']
})
export class StepperComponent implements OnInit {
  stepers: any;
  constructor(private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    // Servicio que llame a los stepps
    this.stepers = [
      { name: "Capturar cédula",
        icon: "far fa-id-card",
        url: "/frontID",
        active: true
      },
      { name: "Capturar Rostro",
        icon: "far fa-user",
        url: "/frontFace",
        active: false
      },
      { name: "Finalizar Enrolamiento",
        icon: "far fa-check-circle",
        url: "/finalResult",
        active: false
      }
    ];
  }
  gotoURL(step: any) {
    if (step.active) {
      this.router.navigateByUrl(step.url);
    } else {
      this.notificationService.showError("Aún no podemos navegar hasta: " + step.name, "Error");
    }
  }
}
